import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/global.css';

// Block pinch-zoom on all browsers (Samsung Internet ignores CSS touch-action)
// Exception: elements with data-allow-pinch attribute (e.g. photo viewer)
document.addEventListener('touchstart', (e) => {
  if (e.touches.length > 1) {
    const target = e.target as HTMLElement;
    if (target.closest('[data-allow-pinch]')) return; // Allow pinch on photo viewer
    e.preventDefault();
  }
}, { passive: false });
document.addEventListener('gesturestart', (e) => {
  const target = e.target as HTMLElement;
  if (target.closest('[data-allow-pinch]')) return;
  e.preventDefault();
});

// iOS: scroll focused input into view when keyboard opens — only if not already visible
document.addEventListener('focusin', (e) => {
  const el = e.target;
  if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
    setTimeout(() => {
      const rect = el.getBoundingClientRect();
      const vh = window.visualViewport?.height ?? window.innerHeight;
      // Only scroll if the input is actually outside the visible area
      if (rect.bottom > vh || rect.top < 0) {
        el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }, 350);
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
